export enum ClientIdConfigurator {
  Carportview = 'carportview',
  Shedview = 'shedview',
}
